import { useEffect, useMemo } from 'react';
import Dropdown from '../../../Components/Form/Inputs/Dropdown';
import LabelWithTooltip from '../../../Components/Form/Inputs/LabelWithTooltip';
import useLanguage from '../../../Services/Language/useLanguageHook';

type ForwardCurveEndDateOptionsType = { label: string; value: number };

interface IForwardCurveEndDateDropdownProps {
    disabled?: boolean;
    value: number | undefined;
    handleChange: (value: number | undefined) => void;
    label?: string;
}

const ForwardCurveEndDateDropdown: React.FC<IForwardCurveEndDateDropdownProps> = (props): JSX.Element => {
    const [translations] = useLanguage();

    const forwardCurveEndDateDropdownOptions = useMemo(
        () => [
            {
                label: translations.words.select,
                value: undefined,
            },
            {
                label: translations.calculators.basis.form.threeMonths,
                value: 3,
            },
            {
                label: translations.calculators.basis.form.sixMonths,
                value: 6,
            },
            {
                label: translations.calculators.basis.form.nineMonths,
                value: 9,
            },
            {
                label: translations.calculators.basis.form.twelveMonths,
                value: 12,
            },
            {
                label: translations.calculators.basis.form.fifteenMonths,
                value: 15,
            },
            {
                label: translations.calculators.basis.form.eighteenMonths,
                value: 18,
            },
        ],
        [translations],
    ) as ForwardCurveEndDateOptionsType[];

    useEffect(() => {
        if (props.value) {
            return;
        }

        props.handleChange(forwardCurveEndDateDropdownOptions[0].value);
    }, []);

    return (
        <LabelWithTooltip
            title={
                <Dropdown
                    disabled={props.disabled ?? false}
                    value={props.value}
                    options={forwardCurveEndDateDropdownOptions}
                    handleOptionChange={(value: number) => props.handleChange(value)}
                    label={props.label}
                    track={{ eventCategory: 'ForwardSpreadCalculator', eventAction: 'ChartEndDateChanged' }}
                />
            }
            tooltip={translations.calculators.basis.form.forwardCurveEndDate}
        />
    );
};

export default ForwardCurveEndDateDropdown;
